export default "__VITE_ASSET__B6TTvcr5__";